module.exports = __webpack_public_path__ + "img/git-hub.acad4b8a.svg";